/**
 * Turns off Zod's JIT mode in the browser. Import this BEFORE anything that builds a schema.
 *
 * Zod 4 probes whether eval is allowed by running `new Function("")` the first time an object schema is
 * built, and uses a generated fast path if it succeeds. The app's content-security-policy forbids eval,
 * so the probe always fails and Zod falls back to its normal parse path, but every page load still sent
 * a CSP violation report (and a log block) to the server. With `jitless` set, Zod never makes the probe;
 * parsing behaves exactly as it already did, minus the report. The server is unaffected (it may eval).
 */

import { z } from 'zod';

z.config({ jitless: true });
